import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { LoginComponent } from './shared/login/login.component';
import { ForgotPasswordComponent } from './shared/forgot-password/forgot-password.component';
import { SharedSetPasswordComponent } from './shared/set-password/shared-set-password.component';
import { PageNotFoundComponent } from './shared/page-not-found/page-not-found.component';
import { PageUnauthorizedComponent } from './shared/page-unauthorized/page-unauthorized.component';
import { SupportRequestComponent } from './shared/support-request/support-request.component';
import { SupportComponent } from './shared/support/support.component';

const routes: Routes = [
  {
    path: 'patient',
    loadChildren: () => import('./patient/patient.module').then(m => m.PatientModule),
  },
  {
    path: 'therapist',
    loadChildren: () => import('./therapist/therapist.module').then(m => m.TherapistModule)
  },
  {
    path: 'admin',
    loadChildren: () => import('./admin/admin.module').then(m => m.AdminModule)
  },
  {
    path: 'login',
    component: LoginComponent,
  },
  {
    path: 'forgot-password',
    component: ForgotPasswordComponent,
  },
  {
    path: 'set-password/:emailId/:resetToken',
    component: SharedSetPasswordComponent,
  },
  {
    path: 'set-password/:emailId/:registrationstatus/:resetToken',
    component: SharedSetPasswordComponent,
  },
  {
    path: 'support',
    component: SupportRequestComponent
  },
  {
    path: 'support-request',
    component: SupportComponent
  },
  {
    path: '',
    redirectTo: '/login',
    pathMatch: 'full'
  },
  {
    path: '404',
    component: PageNotFoundComponent,
  },
  {
    path: '401',
    component: PageUnauthorizedComponent,
  },
  {
    path: '**',
    redirectTo: '404',
  },
];

@NgModule({
  imports: [RouterModule.forRoot(routes, { onSameUrlNavigation: 'reload' })],
  exports: [RouterModule]
})
export class AppRoutingModule { }
